// @givmo/app-charity — app-level constants.
//
// The README "Per-app X-Request-Id prefixes" table fixes the charity prefix as `ch` (admin uses
// `wb`, super-admin `sa`, donate `dw`). Typed as the api-client's `RequestIdPrefix` so a drift from
// the allowed set is a compile error.

import type { RequestIdPrefix } from '@givmo/api-client';
import { CLIENT_PLATFORMS } from '@givmo/observability';

/** Workspace package name. */
export const APP_NAME = '@givmo/app-charity' as const;

/** The charity portal's X-Request-Id prefix (README contract — CPA-WEB1; admin uses `wb`). */
export const CHARITY_REQUEST_ID_PREFIX: RequestIdPrefix = 'ch';

/** Back-compat alias for the placeholder export name (every app exports `REQUEST_ID_PREFIX`). */
export const REQUEST_ID_PREFIX = CHARITY_REQUEST_ID_PREFIX;

/** The `X-Client-Platform` telemetry token for this app. */
export const CHARITY_CLIENT_PLATFORM = CLIENT_PLATFORMS.charityWeb;

/** External legal links surfaced in the app shell (parity with the admin `TERMS_URL`/`PRIVACY_URL`). */
export const TERMS_URL = 'https://givmocharitable.org/terms' as const;
export const PRIVACY_URL = 'https://givmocharitable.org/privacy' as const;

// No `SUPPORT_URL` here on purpose: help/support is the IN-APP `/support` route, which the top-bar
// help icon and both claim-flow "contact support" links point at. The former external destination,
// `https://www.givmo.io/support`, 404s on the live marketing site (EP-FIX7) — do not reintroduce it.
